var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "BulkRentalServiceEditor",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              resourceTitle: _vm._f("pgettext")(
                "Rental Services",
                "BulkRentalServiceEditor|ResourceTitle"
              ),
              resourceKey: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    id: _vm.formId,
                    name: _vm.formName,
                    autofocus: "first"
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "service",
                        label: _vm._f("pgettext")("Service", "RentalService"),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "service_enabled" },
                              model: {
                                value: _vm.item.$updates.service,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "service", $$v)
                                },
                                expression: "item.$updates.service"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormSelect2", {
                        attrs: {
                          name: "service",
                          dataSource: _vm.b_3468003412020058_dataSource,
                          "bind-object": "",
                          valueField: "id",
                          textField: "name",
                          disabled: !_vm.item.$updates.service,
                          required: ""
                        },
                        on: {
                          optionSelected: function($event) {
                            return _vm.evh_3468003412020058_optionSelected(
                              $event,
                              {}
                            )
                          }
                        },
                        model: {
                          value: _vm.item.service,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "service", $$v)
                          },
                          expression: "item.service"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "valid_from",
                        label: _vm._f("gettext")("Valid From"),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "valid_from_enabled" },
                              model: {
                                value: _vm.item.$updates.valid_from,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "valid_from", $$v)
                                },
                                expression: "item.$updates.valid_from"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormDatetime", {
                        staticClass: "w-auto",
                        attrs: {
                          name: "valid_from",
                          disabled: !_vm.item.$updates.valid_from
                        },
                        model: {
                          value: _vm.item.valid_from,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "valid_from", $$v)
                          },
                          expression: "item.valid_from"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "valid_to",
                        label: _vm._f("gettext")("Valid To"),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "valid_to_enabled" },
                              model: {
                                value: _vm.item.$updates.valid_to,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "valid_to", $$v)
                                },
                                expression: "item.$updates.valid_to"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormDatetime", {
                        staticClass: "w-auto",
                        attrs: {
                          name: "valid_to",
                          disabled: !_vm.item.$updates.valid_to
                        },
                        model: {
                          value: _vm.item.valid_to,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "valid_to", $$v)
                          },
                          expression: "item.valid_to"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "intermediated_service",
                        label: _vm._f("gettext")("Intermediated service"),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "intermediated_service_enabled" },
                              model: {
                                value: _vm.item.$updates.intermediated_service,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.item.$updates,
                                    "intermediated_service",
                                    $$v
                                  )
                                },
                                expression:
                                  "item.$updates.intermediated_service"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormCheckbox", {
                        staticClass: "w-auto",
                        attrs: {
                          type: "number",
                          name: "intermediated_service",
                          disabled: !_vm.item.$updates.intermediated_service
                        },
                        model: {
                          value: _vm.item.intermediated_service,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "intermediated_service", $$v)
                          },
                          expression: "item.intermediated_service"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "inflation_indexed",
                        label: _vm._f("gettext")("Inflation indexed"),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "inflation_indexed_enabled" },
                              model: {
                                value: _vm.item.$updates.inflation_indexed,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.item.$updates,
                                    "inflation_indexed",
                                    $$v
                                  )
                                },
                                expression: "item.$updates.inflation_indexed"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormCheckbox", {
                        staticClass: "w-auto",
                        attrs: {
                          type: "number",
                          name: "inflation_indexed",
                          disabled: !_vm.item.$updates.inflation_indexed
                        },
                        model: {
                          value: _vm.item.inflation_indexed,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "inflation_indexed", $$v)
                          },
                          expression: "item.inflation_indexed"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tariffs && _vm.tariffs.length
                    ? _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "tariff_code",
                            label: _vm._f("pgettext")(
                              "Tariff",
                              "RentalService"
                            ),
                            labelColsMd: "4",
                            contentColsMd: "8",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group"
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: { name: "tariff_code_enabled" },
                                  model: {
                                    value: _vm.item.$updates.tariff_code,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.$updates,
                                        "tariff_code",
                                        $$v
                                      )
                                    },
                                    expression: "item.$updates.tariff_code"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpFormSelect2", {
                            attrs: {
                              name: "tariff_code",
                              options: _vm.tariffs,
                              clearable: "",
                              valueField: "code",
                              textField: "code,name",
                              disabled: !_vm.item.$updates.tariff_code
                            },
                            model: {
                              value: _vm.item.tariff_code,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "tariff_code", $$v)
                              },
                              expression: "item.tariff_code"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "billing_unit",
                        label: _vm._f("pgettext")(
                          "Billing unit",
                          "RentalService"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "billing_unit_enabled" },
                              model: {
                                value: _vm.item.$updates.billing_unit,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.item.$updates,
                                    "billing_unit",
                                    $$v
                                  )
                                },
                                expression: "item.$updates.billing_unit"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormSelect2", {
                        attrs: {
                          name: "billing_unit",
                          options: _vm.units,
                          valueField: "symbol",
                          textField: "symbol",
                          disabled: !_vm.item.$updates.billing_unit
                        },
                        model: {
                          value: _vm.item.billing_unit,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "billing_unit", $$v)
                          },
                          expression: "item.billing_unit"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr", { staticClass: "my-4" }),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      staticClass: "col",
                      attrs: {
                        name: "notes",
                        label: _vm._f("pgettext")("Notes", "RentalService"),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "notes_enabled" },
                              model: {
                                value: _vm.item.$updates.notes,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "notes", $$v)
                                },
                                expression: "item.$updates.notes"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormTextarea", {
                        attrs: {
                          name: "notes",
                          disabled: !_vm.item.$updates.notes
                        },
                        model: {
                          value: _vm.item.notes,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "notes", $$v)
                          },
                          expression: "item.notes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Save", "Button"),
                  disabled:
                    !_vm.forms[_vm.formName] ||
                    !_vm.forms[_vm.formName].submittable,
                  type: "submit",
                  form: _vm.formId,
                  variant: "primary",
                  icon: "fa-save",
                  spinning: _vm.actions.save.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: { text: _vm._f("gettext")("Close"), variant: "default" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }